// Keep one failed signed URL from triggering an unbounded image-error/refetch loop.
export function shouldRefreshDamageControlPreview(failedUrls, url) {
  if (!url || failedUrls.includes(url)) return false;
  failedUrls.push(url);
  return true;
}
